<template>
  <div id="proxy-steps">
    <v-stepper v-model="proxyStep" alt-labels non-linear>
      <v-stepper-header>
        <v-stepper-step editable step="1">Item Information</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="2">Customer Information</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="3">Shipping Method</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-select label="Product"
                    v-model="project.product.name"
                    :items="products"
                    item-text="name"
                    item-value="name"
                    validate-on-blur
          />

          <v-text-field label="Item Name"
                        v-model="project.name"
                        :rules="requiredRules"
                        validate-on-blur
          />

          <item-summary :project="project"/>
        </v-stepper-content>

        <v-stepper-content step="2">
          <contact-input
            contact-title="Shipping Information"
            :show-res-check-box="true"
            :contact="shippingAddress"
            @change="changeContact($event)"
          />
        </v-stepper-content>

        <v-stepper-content step="3">
          <shipping-methods
            :shipping-method="shippingMethod"
            :address="shippingAddress"
            :item="project"
            @change="$emit('save-shipping-method', $event)"
          />
        </v-stepper-content>

      </v-stepper-items>
      <v-layout>
        <v-flex s12 class="text-sm-right">
          <v-btn v-if="proxyStep > 1" @click="proxyStep -= 1">Back</v-btn>
          <v-btn color="primary"
                 v-if="proxyStep < 3"
                 @click="saveAndNext($event)">Continue</v-btn>
        </v-flex>
      </v-layout>
    </v-stepper>
  </div>
</template>

<script>
  import ContactInput from '../../widgets/contact-input'
  import ItemSummary from '../../widgets/item-summary'
  import ShippingMethods from '../../widgets/shipping-methods'

  export default {
    components: {
      contactInput: ContactInput,
      itemSummary: ItemSummary,
      shippingMethods: ShippingMethods
    },

    props: {
      project: Object,
      shippingAddress: Object,
      shippingMethod: String
    },

    data () {
      return {
        proxyStep: 1,
        requiredRules: [
          v => !!v || 'Cannot be blank'
        ]
      }
    },

    computed: {
      products () {
        return this.$store.state.products
      }
    },

    methods: {
      changeContact (data) {
        console.log('Update contact info', data)
        this.$emit('save-shipping-address', data)
      },

      saveAndNext (event) {
        this.proxyStep = parseInt(this.proxyStep) + 1
        this.$emit('save-project', event)
      }
    },

    beforeMount () {
      this.$store.dispatch('loadStates')
      this.$store.dispatch('loadCountries')
      this.$store.dispatch('loadProducts')
    }
  }
</script>



// WEBPACK FOOTER //
// steps.vue?674bcf20